import { api } from "jiffy-api";
import { hasConsentedToSocialMediaConversion } from "common/utils/ui/iub-consent-utils";
import { notifyError } from "common/utils/app-monitoring/notify";

const $getOrderNumber = () => document.querySelector(".js-order-number-container");

const sendServerSideConversion = async (eventName, data) => {
  if (!hasConsentedToSocialMediaConversion()) {
    return;
  }

  try {
    const payload = {
      event_id: data.event_id,
      order_number: data.order_number ?? $getOrderNumber()?.dataset?.orderNumber,
      event_name: eventName,
      source_url: window.location.href,
      value: data.event_value
    };

    if (data.product_id != null) {
      payload.product_id = data.product_id;
    }
    if (data.composition_id != null) {
      payload.composition_id = data.composition_id;
    }

    // Best-effort analytics; request-layer rejections are non-actionable and
    // silenced via { silent: true } (HB-1851 convention).
    await api.product.sendSocialMediaConversionApi(payload, { silent: true });
  } catch (error) {
    // Suppress request-layer rejections (handled via { silent: true }) and
    // network-failure rethrows. Surface only synchronous JS programmer errors
    // (TypeError on undefined data, etc.) so future caller regressions stay
    // visible.
    if (error instanceof TypeError) {
      notifyError(`Error preparing ${eventName} conversion event`, { context: { error } });
    }
  }
};

export default sendServerSideConversion;
